
// Logo wordmark — Horizon's header-logo block only shows the image OR a
// plain text fallback (never both), so we inject a styled "Genie Maart"
// wordmark next to the logo image via JS.
(function(){
  function addWordmark(){
    var logoLink = document.querySelector('a.header-logo');
    if (!logoLink || logoLink.querySelector('.gm-logo-wordmark')) return;
    var imageContainer = logoLink.querySelector('.header-logo__image-container--original');
    if (!imageContainer) return;
    var wordmark = document.createElement('span');
    wordmark.className = 'gm-logo-wordmark';
    wordmark.innerHTML = '<span class="gm-logo-wordmark__genie">Genie</span><span class="gm-logo-wordmark__maart">Maart</span>';
    imageContainer.insertAdjacentElement('afterend', wordmark);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addWordmark);
  } else {
    addWordmark();
  }
})();

// Sitewide floating WhatsApp button
(function(){
  function addWhatsAppFloat(){
    if (document.getElementById('gm-wa-float')) return;
    var a = document.createElement('a');
    a.id = 'gm-wa-float';
    a.href = 'https://wa.me/971544781135?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20products.';
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat on WhatsApp');
    a.innerHTML = '<svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.48 1.32 5L2 22l5.25-1.38c1.45.79 3.08 1.21 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.876 9.876 0 0 0 12.04 2zm0 18.13h-.01c-1.48 0-2.94-.4-4.21-1.14l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.37c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.83c0 4.55-3.7 8.21-8.22 8.21zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.17.24-.64.81-.78.97-.15.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.24-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.56-1.36-.77-1.86-.2-.49-.41-.42-.56-.43-.14 0-.31-.01-.47-.01-.17 0-.43.06-.66.31-.23.24-.86.85-.86 2.06 0 1.22.88 2.4 1 2.56.13.17 1.73 2.65 4.2 3.71.59.25 1.05.4 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.19.21-.58.21-1.08.14-1.19-.06-.11-.23-.17-.48-.29z"/></svg>';
    document.body.appendChild(a);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addWhatsAppFloat);
  } else {
    addWhatsAppFloat();
  }
})();

// Footer redesign height fix — ROOT CAUSE (found by reading Horizon's own
// sections/footer.liquid {% stylesheet %} block directly):
//   .footer-content { contain: content; content-visibility: auto; ... }
// content-visibility:auto skips layout for off-screen content and substitutes
// a near-zero intrinsic size (here, exactly the block padding: 56+40=96px)
// until the browser's own heuristics decide it's near-viewport. Our columns
// (6-7 stacked links each) never got a correct height because of this, and
// {% stylesheet %} output is layer-scoped, so a plain CSS override loses to
// it regardless of specificity — inline style is the reliable fix.
(function(){
  function fixFooterHeight(){
    var content = document.querySelector('[id*="footer_m9NzUG"] .footer-content');
    if (!content || content.dataset.gmHeightFixed) return;
    content.dataset.gmHeightFixed = '1';
    content.style.setProperty('content-visibility', 'visible', 'important');
    content.style.setProperty('contain', 'none', 'important');
    content.style.setProperty('height', 'auto', 'important');
    content.style.setProperty('display', 'flex', 'important');
    content.style.setProperty('flex-wrap', 'wrap', 'important');
    content.style.setProperty('align-items', 'flex-start', 'important');
    content.querySelectorAll(':scope > .group-block').forEach(function(gb){
      gb.style.setProperty('flex', '1 1 220px', 'important');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixFooterHeight);
  } else {
    fixFooterHeight();
  }
})();

(function(){
  if (!window._gmDone) window._gmDone = new WeakSet();
  var done = window._gmDone;

  // Read config — falls back to defaults if section not present
  function cfg(key, def){
    return (window.GM_CONFIG && window.GM_CONFIG[key] !== undefined)
      ? window.GM_CONFIG[key] : def;
  }

  function stars(n){
    var s=''; for(var i=0;i<parseInt(n||5);i++) s+='★'; return s;
  }

  function deliveryDate(){
    if(!cfg('useAutoDate', true)) return cfg('customDateText','Get it within 3–7 business days');
    var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var a=new Date(); a.setDate(a.getDate()+3);
    var b=new Date(); b.setDate(b.getDate()+7);
    return 'Get it between '+M[a.getMonth()]+' '+a.getDate()+' – '+M[b.getMonth()]+' '+b.getDate();
  }

  window._gmProcessCards = processCards;
  function processCards(){
    document.querySelectorAll('product-card').forEach(function(card){
      if(done.has(card)) return;
      done.add(card);

      var overlayLink = card.querySelector('a.product-card__link');
      var href = overlayLink ? overlayLink.getAttribute('href') : '#';
      var variantInput = card.querySelector('input[name="id"]');
      var variantId    = variantInput ? variantInput.value : '';

      // ── Badges on gallery ──
      var gallery = card.querySelector('.card-gallery');
      if(gallery){
        var bestText = cfg('bestPickText','Best Pick');
        if(bestText){
          var best = document.createElement('div');
          best.className = 'gm-badge-best';
          best.innerHTML = '🏷️ ' + bestText;
          gallery.appendChild(best);
        }

        // Discount % (if compare-at price exists) OR corner badge
        var pp = card.querySelector('product-price');
        var compareEl = pp ? pp.querySelector('[class*="compare"], s') : null;
        var priceEl   = pp ? pp.querySelector('span.price') : null;
        var saleVal   = priceEl   ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g,''))   : 0;
        var compVal   = compareEl ? parseFloat(compareEl.textContent.replace(/[^0-9.]/g,'')) : 0;

        var corner = document.createElement('div');
        if(compVal > saleVal && saleVal > 0){
          corner.className = 'gm-badge-off';
          corner.textContent = Math.round((compVal-saleVal)/compVal*100) + '% Off';
        } else {
          var cText = cfg('badgeText','✶ New');
          if(cText){ corner.className='gm-badge-corner'; corner.textContent=cText; }
        }
        if(corner.className) gallery.appendChild(corner);
      }

      // ── Extras after <product-price> ──
      var productPrice = card.querySelector('product-price');
      if(!productPrice) return;

      var starsHtml  = cfg('showFreeDelivery',true)
        ? '<div class="gm-free-del">🚚 <span>'+cfg('freeDeliveryText','Free delivery')+'</span></div>'
        : '';
      var stripText  = cfg('deliveryStripText','STANDARD DELIVERY');
      var dateText   = deliveryDate();
      var vendorText = cfg('vendorName','Geniemaart');
      var starsStr   = stars(cfg('starsCount','5'));

      var extras = document.createElement('div');
      extras.innerHTML =
        '<div class="gm-stars-row"><span class="gm-stars">'+starsStr+'</span><span>'+vendorText+'</span></div>'+
        starsHtml +
        '<div class="gm-std-strip">📦 '+stripText+'</div>'+
        '<div class="gm-del-date">'+dateText+'</div>'+
        '<div class="gm-action-row">'+
          '<a href="'+href+'" class="gm-view-btn">View Details</a>'+
          '<button type="button" class="gm-buy-btn">Buy Now →</button>'+
        '</div>';

      productPrice.insertAdjacentElement('afterend', extras);

      // Wire Buy Now → native quick-add (AJAX, no reload)
      extras.querySelector('.gm-buy-btn').addEventListener('click',function(e){
        e.preventDefault();
        var nativeBtn = card.querySelector('.quick-add__button--add, add-to-cart-component button');
        if(nativeBtn){
          var qa = card.querySelector('.quick-add');
          if(qa) qa.style.setProperty('display','flex','important');
          nativeBtn.click();
          setTimeout(function(){ if(qa) qa.style.removeProperty('display'); }, 600);
        } else if(variantId){
          var f=document.createElement('form');
          f.method='post'; f.action='/cart/add';
          f.innerHTML='<input name="id" value="'+variantId+'"><input name="quantity" value="1">';
          document.body.appendChild(f); f.submit();
        } else { window.location.href=href; }
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ setTimeout(processCards,400); });
  } else { setTimeout(processCards,400); }
  setTimeout(processCards,1400);
})();

// ── PDP trust widget ──────────────────────────────────────────────────────
(function injectPDP() {
  function setupPDP() {
    var sec = document.querySelector('.product-information');
    if (!sec || sec.dataset.gmPdp) return;
    sec.dataset.gmPdp = '1';
    var priceEl = sec.querySelector('product-price, .price__current, [data-component="product-price"]');
    if (!priceEl) return;
    var trustBar = document.createElement('div');
    trustBar.className = 'gm-pdp-trust';
    trustBar.innerHTML =
      '<div class="gm-pdp-stars">★★★★★</div>' +
      '<span class="gm-pdp-rating">4.9 (120 reviews)</span>' +
      '<span class="gm-pdp-badge">✅ Best Pick</span>' +
      '<span class="gm-pdp-badge">🏆 Top Seller</span>';
    var deliveryBar = document.createElement('div');
    deliveryBar.className = 'gm-pdp-delivery';
    deliveryBar.innerHTML =
      '<div class="gm-pdp-delivery-row"><span class="icon">🚚</span><div><strong>Free Delivery</strong> on orders above AED 200</div></div>' +
      '<div class="gm-pdp-delivery-row"><span class="icon">📦</span><div>Estimated delivery: <strong>Aug 26 – Aug 30</strong></div></div>' +
      '<div class="gm-pdp-delivery-row"><span class="icon">↩️</span><div><strong>7-Day</strong> hassle-free returns</div></div>' +
      '<div class="gm-pdp-delivery-row"><span class="icon">🔒</span><div><strong>Secure Payment</strong> — SSL protected checkout</div></div>';
    var insertAfter = priceEl.closest('.product-price, product-price') || priceEl;
    insertAfter.insertAdjacentElement('afterend', deliveryBar);
    insertAfter.insertAdjacentElement('afterend', trustBar);
  }
  if (document.querySelector('.product-information')) {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(setupPDP, 500); });
    setTimeout(setupPDP, 800);
  }
})();

// ── Grid Carousel (native product-card sections) ──────────────────────────────
(function() {
  var SECTION_IDS = ['prod_fragrance', 'prod_health_beauty', 'prod_smart_watches'];
  var PREFIX = 'shopify-section-template--22963022266499__';

  function buildCarousel(section) {
    if (section.dataset.gmSlider) return;
    section.dataset.gmSlider = '1';
    section.classList.add('gm-slider-section');

    // Grid resource-list is the target
    var list = section.querySelector('.resource-list--grid');
    if (!list) return;

    // Only direct children are the product items
    var items = Array.from(list.querySelectorAll(':scope > .resource-list__item'));
    if (items.length <= 5) return;  // nothing to scroll

    // Wrap the list in a clipping viewport
    var viewport = document.createElement('div');
    viewport.className = 'gm-slider-viewport';
    list.parentNode.insertBefore(viewport, list);
    viewport.appendChild(list);
    list.classList.add('gm-slider-track');

    // State
    var current = 0;
    var VISIBLE = 5;
    var total   = items.length;

    function step() {
      return items[0] ? (items[0].offsetWidth + 12) : 0;
    }

    function slideTo(idx) {
      current = Math.max(0, Math.min(idx, total - VISIBLE));
      list.style.transform = 'translateX(-' + (current * step()) + 'px)';
      prevBtn.disabled = (current === 0);
      nextBtn.disabled = (current >= total - VISIBLE);
    }

    // Buttons inside the section's page-width container
    var inner = section.querySelector('.section--page-width') || section;
    if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'gm-slider-btn gm-slider-prev';
    prevBtn.innerHTML = '&#8592;';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.disabled = true;
    prevBtn.addEventListener('click', function() { slideTo(current - 1); });

    var nextBtn = document.createElement('button');
    nextBtn.className = 'gm-slider-btn gm-slider-next';
    nextBtn.innerHTML = '&#8594;';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.addEventListener('click', function() { slideTo(current + 1); });

    inner.appendChild(prevBtn);
    inner.appendChild(nextBtn);

    // Init after paint so card widths are measured correctly
    setTimeout(function() { slideTo(0); }, 200);
    window.addEventListener('resize', function() { slideTo(current); });
  }

  function initAll() {
    SECTION_IDS.forEach(function(secId) {
      var el = document.getElementById(PREFIX + secId);
      if (el) buildCarousel(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initAll, 400); });
  } else {
    setTimeout(initAll, 400);
  }
})();

// ── MutationObserver: process cards injected after page load (e.g. recommendations AJAX) ──
(function() {
  var pending = false;
  function scheduleProcess() {
    if (pending) return;
    pending = true;
    setTimeout(function() {
      pending = false;
      if (window._gmProcessCards) window._gmProcessCards();
    }, 150);
  }

  var obs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'PRODUCT-CARD' || (n.querySelector && n.querySelector('product-card'))) {
          scheduleProcess();
          break;
        }
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

// ── PDP Image Gallery thumbnails ─────────────────────────────────────────────
(function() {
  function buildPDPGallery() {
    // The gallery is a custom element <media-gallery>, NOT a class
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.gmGallery) return;

    var sc = gallery.querySelector('slideshow-component');
    if (!sc) return;

    var slides = Array.from(gallery.querySelectorAll('slideshow-slides slideshow-slide'));
    if (slides.length < 2) return;

    gallery.dataset.gmGallery = '1';

    var strip = document.createElement('div');
    strip.className = 'gm-pdp-thumbs';

    var thumbBtns = [];

    slides.forEach(function(slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;

      // Use 240-wide version for thumbnail
      var src = (img.currentSrc || img.src || '').replace(/([?&]width=)\d+/, '$1240');
      if (!src) return;

      var btn = document.createElement('button');
      btn.className = 'gm-pdp-thumb' + (i === 0 ? ' gm-pdp-thumb--active' : '');
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      btn.setAttribute('type', 'button');

      var tImg = document.createElement('img');
      tImg.src = src;
      tImg.alt = '';
      tImg.loading = 'lazy';
      btn.appendChild(tImg);

      btn.addEventListener('click', function() {
        sc.select(i);
        thumbBtns.forEach(function(t) { t.classList.remove('gm-pdp-thumb--active'); });
        btn.classList.add('gm-pdp-thumb--active');
      });

      strip.appendChild(btn);
      thumbBtns.push(btn);
    });

    // Insert strip right after slideshow-component
    sc.parentNode.insertBefore(strip, sc.nextSibling);

    // Sync active thumb when slideshow scrolls
    var slidesEl = gallery.querySelector('slideshow-slides');
    if (slidesEl) {
      slidesEl.addEventListener('scroll', function() {
        var w = slidesEl.offsetWidth;
        if (!w) return;
        var idx = Math.round(slidesEl.scrollLeft / w);
        thumbBtns.forEach(function(t, i) {
          t.classList.toggle('gm-pdp-thumb--active', i === idx);
        });
      }, { passive: true });
    }
  }

  function tryBuild() {
    if (document.querySelector('media-gallery slideshow-component')) {
      buildPDPGallery();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(tryBuild, 600); });
  } else {
    setTimeout(tryBuild, 600);
  }
})();

// ── PDP custom lightbox — fully replaces Horizon's native zoom-dialog
// (native one is a full-page vertical-scroll gallery, not a single-image lightbox) ──
(function(){
  var lb = null, lbImg = null, lbCounter = null, lbPrev = null, lbNext = null;
  var images = [];
  var currentIndex = 0;

  function hiRes(src){
    if (!src) return src;
    return src.replace(/([?&]width=)\d+/, '$11800');
  }

  function collectImages(){
    var slides = document.querySelectorAll('media-gallery > slideshow-component slideshow-slide img');
    images = Array.from(slides).map(function(img){
      return { src: hiRes(img.currentSrc || img.src), alt: img.alt || '' };
    });
  }

  function buildLightbox(){
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'gm-lightbox';
    lb.innerHTML =
      '<button type="button" class="gm-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="gm-lightbox__arrow gm-lightbox__arrow--prev" aria-label="Previous image">&#8249;</button>' +
      '<div class="gm-lightbox__stage"><img class="gm-lightbox__img" alt=""></div>' +
      '<button type="button" class="gm-lightbox__arrow gm-lightbox__arrow--next" aria-label="Next image">&#8250;</button>' +
      '<div class="gm-lightbox__counter"></div>';
    document.body.appendChild(lb);

    lbImg = lb.querySelector('.gm-lightbox__img');
    lbCounter = lb.querySelector('.gm-lightbox__counter');
    lbPrev = lb.querySelector('.gm-lightbox__arrow--prev');
    lbNext = lb.querySelector('.gm-lightbox__arrow--next');

    lb.querySelector('.gm-lightbox__close').addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e){ if (e.target === lb) closeLightbox(); });
    lbPrev.addEventListener('click', function(){ showIndex(currentIndex - 1); });
    lbNext.addEventListener('click', function(){ showIndex(currentIndex + 1); });

    document.addEventListener('keydown', function(e){
      if (!lb.classList.contains('gm-lightbox--open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showIndex(currentIndex - 1);
      if (e.key === 'ArrowRight') showIndex(currentIndex + 1);
    });
  }

  function showIndex(i){
    if (!images.length) return;
    currentIndex = (i + images.length) % images.length;
    lbImg.src = images[currentIndex].src;
    lbImg.alt = images[currentIndex].alt;
    lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
    var multi = images.length > 1;
    lbPrev.style.display = multi ? '' : 'none';
    lbNext.style.display = multi ? '' : 'none';
  }

  function getActiveMainIndex(){
    var slidesEl = document.querySelector('media-gallery > slideshow-component slideshow-slides');
    if (!slidesEl) return 0;
    var w = slidesEl.offsetWidth;
    if (!w) return 0;
    return Math.round(slidesEl.scrollLeft / w);
  }

  function openLightbox(){
    collectImages();
    buildLightbox();
    if (!images.length) return;
    document.body.classList.add('gm-lightbox-lock');
    lb.classList.add('gm-lightbox--open');
    showIndex(getActiveMainIndex());
  }

  function closeLightbox(){
    if (!lb) return;
    lb.classList.remove('gm-lightbox--open');
    document.body.classList.remove('gm-lightbox-lock');
    var nativeDialog = document.querySelector('.dialog-zoomed-gallery__dialog');
    if (nativeDialog && nativeDialog.open) nativeDialog.close();
  }

  // Horizon's zoom trigger is a declarative on:click="#zoom-dialog.../open/N"
  // attribute on BOTH the slide itself and the invisible zoom button — read by
  // the theme's own framework-level delegated listener, which fires regardless
  // of any capture-phase listener we attach (attribute-based lookup at click
  // time, not a bound function we can out-race). Stripping the attribute is
  // the only reliable way to disable it.
  function neutralizeNativeTriggers(){
    var scope = document.querySelector('media-gallery > slideshow-component');
    if (!scope) return;
    scope.querySelectorAll('[on\\:click]').forEach(function(el){
      el.removeAttribute('on:click');
    });
    scope.querySelectorAll('.product-media-container__zoom-button').forEach(function(btn){
      btn.remove();
    });
  }

  function attachTrigger(){
    var gallery = document.querySelector('media-gallery > slideshow-component');
    if (!gallery || gallery.dataset.gmLightboxBound) return;
    gallery.dataset.gmLightboxBound = '1';

    neutralizeNativeTriggers();

    gallery.addEventListener('click', function(e){
      var mediaImg = e.target.closest('.product-media img, .product-media-container img');
      if (!mediaImg) return;
      e.preventDefault();
      openLightbox();
    });

    // Re-neutralize if Horizon re-renders slides (e.g. after a variant change)
    new MutationObserver(neutralizeNativeTriggers).observe(gallery, { childList: true, subtree: true });
  }

  function tryAttach(){
    if (document.querySelector('media-gallery > slideshow-component')) attachTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(tryAttach, 600); });
  } else {
    setTimeout(tryAttach, 600);
  }
})();

